
import { useState } from "react";
import Swap from "./components/Swap";
import { Route, Routes } from "react-router-dom";

function App() {
  const [authenticated, setAuthenticated] = useState(localStorage.getItem('authToken')||"");
  return (
    <Routes>
      <Route path="/" element={<Swap />} />
     
    </Routes>
  );
}

export default App;
